import { MultilinkStoryblok } from 'storyblok-types';

export const getStoryblokUrl = (link?: MultilinkStoryblok): string => {
  if (!link) {
    return '';
  }

  return link.linktype === 'story' ? link.story?.url : link.url;
};
